import React, { useState, useEffect } from "react";
import { Card, Col, Container, Row, Table } from "react-bootstrap";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import Loader from "../../../../components/Common/Loader";
import {
  ROOMTYPEDETAIL,
} from "../../../../services/ApiCalls";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";


const RoomTypeDetail = () => {
  const [roomTypeDetail, setRoomTypeDetail] = useState();
  const [loader, setLoader] = useState(false);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page") || 1;
  const { id } = useParams();
  const { t } = useTranslation();


  const getData = async () => {
    try {
      setLoader(true);
      const res = await ROOMTYPEDETAIL(id);
      if (res?.data?.status === "success") {
        setRoomTypeDetail(res.data?.data);
      }
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (id) getData();
  }, [id]);


  console.log("roomTypeDetail", roomTypeDetail);

  return (
    <>
      {loader && <Loader />}
      <section className="roomTypeDetail py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-2">
                <Link
                  to={`/roomtype?page=${page}`}
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#E8307A"
                      stroke="#E8307A"
                      strokeWidth="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("roomType.detailTitle")}
                </h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Card className="p-3 shadow-sm rounded">
                <h5 className="fw-bold mb-3">
                  {t("roomType.images")}
                </h5>

                {roomTypeDetail?.images?.length > 0 ? (
                  roomTypeDetail.images.length === 1 ? (
                    <div className="p-2">
                      <img
                        src={roomTypeDetail.images[0]?.link}
                        alt="room-0"
                        className="rounded shadow-sm"
                        style={{
                          width: "100%",
                          height: 300,
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  ) : (
                    <Slider
                      dots={true}
                      infinite={roomTypeDetail.images.length > 1}
                      speed={500}
                      slidesToShow={Math.min(roomTypeDetail.images.length, 2)}
                      slidesToScroll={1}
                      arrows={roomTypeDetail.images.length > 1}
                      responsive={[
                        {
                          breakpoint: 1024,
                          settings: {
                            slidesToShow: Math.min(roomTypeDetail.images.length, 3),
                          },
                        },
                        {
                          breakpoint: 768,
                          settings: {
                            slidesToShow: Math.min(roomTypeDetail.images.length, 2),
                          },
                        },
                        { breakpoint: 480, settings: { slidesToShow: 1 } },
                      ]}
                    >
                      {roomTypeDetail.images.map((src, i) => (
                        <div key={i} className="p-2">
                          <img
                            src={src?.link}
                            alt={`room-${i}`}
                            className="rounded shadow-sm"
                            style={{
                              width: "100%",
                              height: 200,
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      ))}
                    </Slider>
                  )
                ) : (
                  <p className="text-muted">
                    {t("common.noImages", "No Images")}
                  </p>
                )}
              </Card>
            </Col>

            <Col lg="12" className="my-2">
              <div
                className="formWrpper px-lg-5 p-md-4 p-3 rounded"
                style={{ background: "#EEEEEE" }}
              >
                {roomTypeDetail ? (
                  <Row className="justify-content-between">
                    <Col md={6} className="my-2">
                      <ul className="list-unstyled ps-0 mb-0 notLastBorder pe-lg-3">
                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t("roomType.columns.hotelName")}:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {roomTypeDetail?.hotelId?.hotelName}
                          </h6>
                        </li>
                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t("manageHotel.columns.hotelId")}:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {roomTypeDetail?.hotelId?.hotelId}
                          </h6>
                        </li>
                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t("roomType.columns.roomType")}:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {roomTypeDetail?.roomType?.name}
                          </h6>
                        </li>
                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t("roomType.columns.totalRoom")}:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {roomTypeDetail?.totalRoom}
                          </h6>
                        </li>
                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t("roomType.columns.availRoom")}:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {roomTypeDetail?.availableRoom}
                          </h6>
                        </li>

                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t("roomType.columns.createdAt")}:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {moment(roomTypeDetail?.createdAt).format("YYYY-MM-DD")}
                          </h6>
                        </li>

                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t("roomType.columns.updatedAt")}:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {moment(roomTypeDetail?.updatedAt).format("YYYY-MM-DD")}
                          </h6>
                        </li>

                      </ul>
                    </Col>

                    <Col md={6} className="my-2">
                      <ul className="list-unstyled mb-0 notLastBorder ps-lg-3">



                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t(
                              "roomType.columns.maxPeopleReq"
                            )}
                            :
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {roomTypeDetail?.maxOccupancy}
                          </h6>
                        </li>
                        {/* <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t(
                              "Extra Child Price"
                            )}
                            :
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {roomTypeDetail?.extraChildPrice}
                          </h6>
                        </li> */}
                        {/* <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t(
                              "Max Child Occupancy"
                            )}
                            :
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {roomTypeDetail?.maxChilOccupancy}
                          </h6>
                        </li> */}
                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t(
                              "Check In Date"
                            )}
                            :
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {roomTypeDetail?.checkInDate}
                          </h6>
                        </li>
                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t(
                              "Check Out Date"
                            )}
                            :
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {roomTypeDetail?.checkOutDate}                          </h6>
                        </li>

                        <li className="py-3 d-flex align-items-start gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t("roomType.columns.roomAmenities")}:
                          </p>
                          <div className="m-0 text-muted w-50 d-flex flex-wrap gap-2">
                            {roomTypeDetail?.amenities?.map((a) => (
                              <span key={a._id} className="badge bg-secondary">
                                {a.name}
                              </span>
                            ))}
                          </div>
                        </li>

                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t("roomType.columns.status")}:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {roomTypeDetail?.status}
                          </h6>
                        </li>
                        <li className="py-3 d-flex align-items-start gap-10">
                          <p className="m-0 themeBlue fw-sbold w-50">
                            {t("roomType.columns.description")}:
                          </p>
                          <p
                            className="m-0 text-muted w-50"
                            style={{ fontSize: 12, lineHeight: "18px" }}
                          >
                            {roomTypeDetail?.description}
                          </p>
                        </li>

                      </ul>
                    </Col>
                    <Col md={12} className="text-muted">
                      <p className="m-0 themeBlue fw-sbold w-50">
                        {t("roomType.columns.pricingType")}:
                      </p>
                      <Table bordered responsive className="align-middle text-center bg-transparent">
                        <thead>
                          <tr>
                            <th className="themeBlue">{t("roomType.columns.pricingType")}</th>
                            <th className="themeBlue">{t("roomType.columns.durationHours")}</th>
                            <th className="themeBlue">{t("roomType.columns.Minimum_stay")}</th>
                            <th className="themeBlue">{t("roomType.columns.price", "Price")}</th>
                            {/* <th className="themeBlue">{t("roomType.columns.discount")}</th> */}
                            {/* <th className="themeBlue">{t("roomType.columns.final_price")}</th> */}
                                                        <th className="themeBlue">{t("roomType.columns.priceType", "price category")}</th>

                            <th className="themeBlue">{t("roomType.columns.startDate", "Start Date")}</th>
                            <th className="themeBlue">{t("roomType.columns.endDate", "End Date")}</th>


                          </tr>
                        </thead>

                        <tbody>
                          {roomTypeDetail?.pricingData?.map((item) => (
                            <tr key={item._id}>
                              <td className="fw-semibold text-capitalize">
                                {item.pricingType}
                              </td>
                              <td>{item.durationHours ?? "-"}</td>
                              <td>{item.minStay ?? "-"}</td>
                              <td>{item?.basePrice}</td>
                              <td>{item?.priceCategory}</td>

                              <td>{item?.startDate?.split("T")[0]}</td>
                              <td>{item?.endDate?.split("T")[0]}</td>


                              {/* <td>{item.discount}%</td> */}
                              {/* <td className="fw-semibold">
                                {item.finalPrice}
                              </td> */}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                ) : (
                  <p className="text-center text-muted">
                    No room type details found
                  </p>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default RoomTypeDetail;
